<div style="display: block">
    <canvas baseChart
            [datasets]="radarChartData"
            [labels]="radarChartLabels"
            [type]="radarChartType"></canvas>
            <a href="#" (click)="downloadCanvas($event)">DOWNLOAD IMAGE</a>
  </div>
